<template>
  <div>
    <div class="row">
      <div class="col--10">
        <input
          class="form-input"
          id="region-search"
          type="text"
          :placeholder="$t('drillDown.searchPlaceholder')"
          v-model="search"
        >
      </div>
      <div class="col--2">
        <app-button btn-type="primary" full-width layout="icon" icon="search" @click="onSearch" />
      </div>
    </div>
    <div class="row mt-4 mb-6">
      <div class="col">
        <app-button btn-type="outline" icon="angle-left" :disabled="history.length < 2" icon-position="left" layout="icon" @click="onBack"/>
      </div>
    </div>

    <template v-if="filteredPayload?.type === 'region'">
      <div class="row mb-4" v-for="region in filteredPayload.payload" :key="region.regionId">
        <!-- {{  region }} -->
        <div class="col">
          <level :label="region.regionName" :item="region" @onItemSelected="onRegionSelected" />
        </div>
      </div>
    </template>
    <template v-else>
      <div class="row mb-4" v-for="site in filteredPayload?.payload" :key="site.siteId">
        <div class="col">
          <level :label="site.siteName" :item="site" @onItemSelected="onSiteSelected" />
        </div>
      </div>
    </template>
    <smtt-toast ref="statusErrorToast" id="errorToast" style="border: none"></smtt-toast>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import SubMenuHeader from '../SubMenuHeader';
import Level from './Level';
import AppButton from '@/components/AppButton';

export default {
  'name': 'DrillDown',
  'components': { SubMenuHeader, AppButton, Level },
  'data': function () {
    return {
      regions: [],
      'returnButtons': [],
      'siteMode': false,
      sites: [],
      history: [],
      search: '',
      filteredPayload: null,
    }
  },
  'methods': {
    ...mapActions([
      'drillDownData',
      'saveAssignment'
    ]),
    'back': function () {
      this.$router.back();
    },
    onRegionSelected(region) {
      if (region.nextRegions.length > 0) {
        this.history.push({
          type: 'region',
          id: region.regionId,
          payload: region.nextRegions,
        })
      } else if (region.sites.length > 0) {
        this.history.push({
          type: 'site',
          id: region.regionId,
          payload: region.sites,
        })
      }

      this.updateFilteredPayload();
    },
    async onSiteSelected(site) {
      try {
        this.$store.commit('showLoading');
        const response = await this.saveAssignment({site: site.siteId});
        if (response.success) {
          this.$router.push({ 'name': 'SiteDetailsScreen', 'params': { 'assignmentId': response.assignmentId } });
        } else {
          this.showError(response.message)
        }
      } catch (error) {
        this.showError(error.response.message)
      } finally {
        this.$store.commit('hideLoading');
      }

      this.updateFilteredPayload();
    },

    onSearch() {
      const currentHistory= this.history[this.history.length - 1];

      let result;
      if (currentHistory.type === 'region') {
        result = currentHistory.payload.filter((item) => {
            return item.regionName.toLowerCase().includes(this.search.toLowerCase());
        });
      }

      if (currentHistory.type === 'site') {
        result = currentHistory.payload.filter((item) => {
          return item.siteName.toLowerCase().includes(this.search.toLowerCase()) ||
          (item.siteCode && item.siteCode.toLowerCase().includes(this.search.toLowerCase()));
        });
      }

      this.filteredPayload = {
        type: currentHistory.type,
        payload: result
      };
    },
    onBack() {
      this.history.pop();
      this.updateFilteredPayload();
    },
    updateFilteredPayload() {
      this.filteredPayload = this.history[this.history.length - 1];
      this.search = '';
    },
    showError(message) {
      const toastElement = this.$refs.statusErrorToast;
      toastElement.error({
        'message': message != null ? this.$t(message.code, message.params) : this.$t('error.default.connection.message'),
        'header': this.$t('error.default.connection.title'),
        'duration': 5000
      })
    }
  },
  async created() {
    try {
      const response = await this.drillDownData();
      if (response.success) {
        this.regions = response.regions;
        this.history.push({
          type: 'region',
          payload: this.regions,
        });

        this.filteredPayload = this.history[this.history.length - 1];
      }
    } catch (error) {
      this.showError(error.response.message)
    }
  }
}
</script>
<style scoped>
  .form-input {
    padding: 0 12px;
    box-shadow: none;
    background-color: rgb(255, 255, 255);
    height: 40px;
    font-size: 0.875rem;
    line-height: 1.5rem;
    flex: 1 1 auto;
    border: 1px solid #4C4D57;
    border-radius: 0.25rem;
    color: #4C4D57;
    width: 100%;
  }

  .form-input:focus {
    box-shadow: rgb(0, 111, 255) 0 0 1px 2px;
    background-color: rgb(255, 255, 255);
    color: rgb(73, 80, 87);
    border-color: rgb(128, 189, 255);
    outline: 0;
  }

  .form-input[disabled] {
    color: #495057;
    background-color: #e9ecef;
  }
</style>